<template>
    <div class="mb-5">
        <div class="__heading d-flex">
            <h2>Transportation Service License</h2>

            <v-tooltip top content-class="charge-text__tooltip">
                <template v-slot:activator="{ on, attrs }">
                    <img v-bind="attrs"
                         v-on="on" src="assets/icons/info.svg"
                         alt="info icon" width="12"
                         class="ml-1" />
                </template>
                <span class="custom--v-tooltip">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aut delectus, dignissimos ex id quod?
                </span>
            </v-tooltip>
        </div>
        <v-row>
            <v-col xl="3" lg="3" md="6" sm="12" cols="12">
                <h4>MC number</h4>

                <v-text-field
                    v-model="transportation_service_license_data.mc_number"
                    dense
                    outlined
                    placeholder="Write a number"
                    class="custom--v-text-field"
                    :error-messages="mcNumberErrors"
                    @input="$v.transportation_service_license_data.mc_number.$touch()"
                    @blur="$v.transportation_service_license_data.mc_number.$touch()"
                >
                </v-text-field>
            </v-col>
            <v-col xl="3" lg="3" md="6" sm="12" cols="12">
                <h4>DOT number</h4>

                <v-text-field
                    v-model="transportation_service_license_data.dot_number"
                    dense
                    outlined
                    placeholder="Write a number"
                    class="custom--v-text-field"
                    :error-messages="dotNumberErrors"
                    @input="$v.transportation_service_license_data.dot_number.$touch()"
                    @blur="$v.transportation_service_license_data.dot_number.$touch()"
                >
                </v-text-field>
            </v-col>
            <v-col xl="3" lg="3" md="6" sm="12" cols="12">
                <h4>Expiration date</h4>

                <date-picker
                    :expiration_date="transportation_service_license_data.expiration_date"
                    :is-clicked-submit="isSubmit"
                    @onChange="(value) => {this.transportation_service_license_data.expiration_date = value}"
                />
            </v-col>
            <v-col xl="3" lg="3" md="6" sm="12" cols="12">
                <h4>State lic/Cer name</h4>

                <v-text-field
                    v-model="transportation_service_license_data.state_lic_issuer"
                    dense
                    outlined
                    placeholder="Write a name"
                    class="custom--v-text-field"
                    :error-messages="staticIssueErrors"
                    @input="$v.transportation_service_license_data.state_lic_issuer.$touch()"
                    @blur="$v.transportation_service_license_data.state_lic_issuer.$touch()"
                >
                </v-text-field>
            </v-col>
            <v-col xl="3" lg="3" md="6" sm="12" cols="12">
                <h4>State Lic/Cer number</h4>

                <v-text-field
                    v-model="transportation_service_license_data.state_lic_number"
                    dense
                    outlined
                    placeholder="Write a number"
                    class="custom--v-text-field"
                    :error-messages="staticNumberErrors"
                    @input="$v.transportation_service_license_data.state_lic_number.$touch()"
                    @blur="$v.transportation_service_license_data.state_lic_number.$touch()"
                >
                </v-text-field>
            </v-col>
            <v-col xl="3" lg="3" md="6" sm="12" cols="12">
                <h4>Authority</h4>

                <v-select
                    v-model="transportation_service_license_data.authority"
                    :items="items"
                    dense outlined
                    placeholder="Choose one"
                    class="custom--v-select"
                    :error-messages="authorityErrors"
                    @input="$v.transportation_service_license_data.authority.$touch()"
                    @blur="$v.transportation_service_license_data.authority.$touch()"
                >
                </v-select>
            </v-col>

            <v-col xl="3" lg="3" md="6" sm="12" cols="12" class="d-flex align-center">
                <v-btn
                    depressed color="secondary"
                    class="custom--v-btn"
                    min-width="80"
                    @click="submit(transportation_service_license_data)"
                >
                    Save
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import DatePicker from "../../components/DatePicker.vue";

export default {
    name: "CredentialsTransportationService",

    components: { DatePicker },

    mixins: [validationMixin],

    props: {
        branchId: {
            type:Number,
            required: true
        }
    },

    validations: {
        transportation_service_license_data: {
            mc_number: { required },
            dot_number: { required },
            state_lic_number: { required },
            state_lic_issuer: { required },
            authority: { required },
            expiration_date: { required }
        },
    },

    data () {
        return {
            transportation_service_license_data: {
                mc_number: '',
                dot_number: '',
                state_lic_number: '',
                state_lic_issuer: '',
                authority: '',
                expiration_date: ''
            },
            items: [
                'Interstate',
                'Intrastate',
                'Both'
            ],
            isSubmit: false
        }
    },

    computed: {
        ...mapGetters('credentials', ['transportation_service_license']),

        mcNumberErrors () {
            const errors = [];
            if (! this.$v.transportation_service_license_data.mc_number.$dirty) return errors;
            ! this.$v.transportation_service_license_data.mc_number.required && errors.push('Field is required');
            return errors;
        },
        dotNumberErrors () {
            const errors = [];
            if (! this.$v.transportation_service_license_data.dot_number.$dirty) return errors;
            ! this.$v.transportation_service_license_data.dot_number.required && errors.push('Field is required');
            return errors
        },
        staticNumberErrors () {
            const errors = [];
            if (! this.$v.transportation_service_license_data.state_lic_number.$dirty) return errors;
            ! this.$v.transportation_service_license_data.state_lic_number.required && errors.push('Field is required');
            return errors;
        },
        staticIssueErrors () {
            const errors = [];
            if (! this.$v.transportation_service_license_data.state_lic_issuer.$dirty) return errors;
            ! this.$v.transportation_service_license_data.state_lic_issuer.required && errors.push('Field is required');
            return errors;
        },

        authorityErrors () {
            const errors = [];
            if (! this.$v.transportation_service_license_data.authority.$dirty) return errors;
            ! this.$v.transportation_service_license_data.authority.required && errors.push('Choose one');
            return errors;
        }
    },

    methods: {
        ...mapActions('credentials', ['update']),

        submit (data) {
            this.$v.$touch();
            this.isSubmit = true;

            //if invalid return false
            if (this.$v.$invalid) {
                return false;
            }

            this.update({
                data_name: 'transportation_service_license',
                data
            });
        }
    },

    created () {
        if (this.transportation_service_license) {
            this.transportation_service_license_data = this.transportation_service_license;
        }
    }
}
</script>